import { render, staticRenderFns } from "./QuestionHistory.vue?vue&type=template&id=1e31e430&scoped=true&"
import script from "./QuestionHistory.vue?vue&type=script&lang=js&"
export * from "./QuestionHistory.vue?vue&type=script&lang=js&"
import style0 from "./QuestionHistory.vue?vue&type=style&index=0&id=1e31e430&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e31e430",
  null
  
)

export default component.exports